import { Button, Dialog, Stack, Typography } from '@vapor/material'
import InsightTsPayPopup from '../../../assets/insight_tspay_popup.png'
import { useReactiveVar } from '@apollo/client'
import { makeVar } from '@apollo/client'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import parse from 'html-react-parser'

type InsightPopupDialog = {
  key: string
  title: string
  message: string
  confirmButtonText: string
  onConfirm: () => void
}

export const insightPopupDialogVar = makeVar<InsightPopupDialog[]>([])

export default function InsightPopupProvider(props: { children?: React.ReactNode }) {
  const insightPopupDialogs = useReactiveVar(insightPopupDialogVar)
  const { t } = useTranslation()

  const closeDialog = useCallback((key: string) => {
    insightPopupDialogVar(insightPopupDialogVar().filter((d) => d.key !== key))
  }, [])

  return (
    <>
      {props.children}
      {insightPopupDialogs.map((d) => {
        return (
          <Dialog open key={d.key} onClose={() => closeDialog(d.key)}>
            <Stack direction="row">
              <img src={InsightTsPayPopup} style={{ maxWidth: '300px', maxHeight: '300px' }} />
              <Stack direction="column" m={2} spacing={2}>
                <Typography variant="titleSmall">{d.title}</Typography>
                <Typography variant="body">{parse(d.message)}</Typography>
                <Stack direction="row" justifyContent="flex-end" alignItems="center">
                  <Button
                    variant="contained"
                    onClick={() => {
                      d.onConfirm()
                      closeDialog(d.key)
                    }}
                  >
                    {parse(d.confirmButtonText)}
                  </Button>
                </Stack>
              </Stack>
            </Stack>
          </Dialog>
        )
      })}
    </>
  )
}
